import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCar } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Select from "react-select";

const Header = ({ title, link, onPrev, onNext, cars, onFilterChange }) => {
  const navigate = useNavigate();

  const handleSeeMore = () => {
    // Handle special cases for multiple categories
    let selectedCategories = [title];
    if (title === "Cabrio-Special") {
      selectedCategories = ["Cabrio", "Special"];
    } else if (title === "Motorbikes - ATV-Quads") {
      selectedCategories = ["Motorbikes", "ATV-Quads"];
    }

    navigate('/search', {
      state: {
        selectedCategory: selectedCategories,
        pickupDate: null,
        dropoffDate: null
      }
    });
  };

  const getFilterOptions = (cars) => {
    const options = {
      transmission: new Set(),
      persons: new Set(),
      suitcases: new Set(),
    };

    cars.forEach((car) => {
      options.transmission.add(
        car.name.includes("Manual") ? "Manual" : "Automatic"
      );
      if (car.persons) options.persons.add(car.persons);
      if (car.suitcases) options.suitcases.add(car.suitcases);
    });

    return {
      transmission: Array.from(options.transmission).map((t) => ({
        value: t,
        label: t,
      })),
      persons: Array.from(options.persons).map((p) => ({
        value: p,
        label: `${p} Persons`,
      })),
      suitcases: Array.from(options.suitcases).map((s) => ({
        value: s,
        label: `${s} Suitcase${s > 1 ? "s" : ""}`,
      })),
    };
  };

  const filterOptions = getFilterOptions(cars);

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8 px-4 md:px-7">
      {/* Title and See More Button */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full md:w-auto">
        <p className="Aleo text-xl">{title}</p>
        <div className="group w-full sm:w-auto">
          <button 
            onClick={handleSeeMore}
            className="flex flex-row w-full sm:w-auto border-b-2 border-b-black border shadow-xl rounded-t-md px-4 sm:px-6 items-center justify-center gap-4 content-center p-3 group-hover:bg-blue-900 group-hover:text-white transition-all ease-in-out duration-300"
          >
            <FaCar className="text-2xl" />
            <p className="text-black uppercase Aleo text-center group-hover:text-white ease-in-out transition-all duration-300">
              See More
            </p>
          </button>
        </div>
      </div>

      {/* Filter and Navigation */}

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 w-full md:w-auto">
          <Select
            isMulti
            placeholder="Filter cars..."
            className="w-full sm:w-64"
            options={[
              { label: "Transmission", options: filterOptions.transmission },
              { label: "Capacity", options: filterOptions.persons },
              { label: "Luggage", options: filterOptions.suitcases },
            ]}
            onChange={onFilterChange}
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "42px",
                borderColor: "#e5e7eb",
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused ? "#f3f4f6" : "white",
                color: "black",
                "&:hover": {
                  backgroundColor: "#f3f4f6",
                },
              }),
            }}
          />
          <div className="flex justify-end gap-2">
            <button
              onClick={onPrev}
              className="bg-white p-3.5 rounded-sm border text-gray-400 hover:bg-blue-900 hover:text-white transition-all flex-1 sm:flex-none"
            >
              <FaChevronLeft />
            </button>
            <button
              onClick={onNext}
              className="bg-white p-3.5 rounded-sm border text-gray-400 hover:bg-blue-900 hover:text-white transition-all flex-1 sm:flex-none"
            >
              <FaChevronRight />
            </button>
          </div>
        </div>
    
    </div>
  );
};

export default Header;
